var Ne = Object.defineProperty, Ie = Object.defineProperties;
var Pe = Object.getOwnPropertyDescriptors;
var q = Object.getOwnPropertySymbols;
var te = Object.prototype.hasOwnProperty, re = Object.prototype.propertyIsEnumerable;
var oe = (e, o, t) => o in e ? Ne(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, p = (e, o) => {
  for (var t in o || (o = {}))
    te.call(o, t) && oe(e, t, o[t]);
  if (q)
    for (var t of q(o))
      re.call(o, t) && oe(e, t, o[t]);
  return e;
}, O = (e, o) => Ie(e, Pe(o));
var w = (e, o) => {
  var t = {};
  for (var r in e)
    te.call(e, r) && o.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && q)
    for (var r of q(e))
      o.indexOf(r) < 0 && re.call(e, r) && (t[r] = e[r]);
  return t;
};
import { jsx as v, jsxs as Te } from "react/jsx-runtime";
import { r as Ee } from "./rem-CMQJ_ZTp.js";
import { forwardRef as De, useState as $e, cloneElement as se, useId as _e, useEffect as ae, useRef as R, useCallback as y } from "react";
import { c as K, a as ne } from "./get-size-Bc1Pz5yf.js";
import { c as ce } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as P, u as N, B as L, h as ke } from "./factory-ueRxoNOV.js";
import { u as ie } from "./use-styles-DToiHEa6.js";
import { P as z } from "./Popover-CchFr99F.js";
import { c as Re } from "./create-safe-context-DqDyoPVE.js";
import { I as de } from "./Input--FNE961U.js";
import { i as V } from "./is-element-C00Aie10.js";
import { g as Le } from "./use-floating-auto-update-Bm7DFrip.js";
import { u as B } from "./use-merged-ref-n551Tfbr.js";
import { u as Fe } from "./use-id-D2tGiO9x.js";
import { u as He } from "./use-uncontrolled-BT_j5D2R.js";
function le(e) {
  return typeof e == "string" ? { value: e, label: e } : "value" in e && !("label" in e) ? { value: e.value, label: e.value, disabled: e.disabled } : typeof e == "number" ? { value: e.toString(), label: e.toString() } : "group" in e ? {
    group: e.group,
    items: e.items.map((o) => le(o))
  } : e;
}
function Oo(e) {
  return e ? e.map((o) => le(o)) : [];
}
function qe(e) {
  return e.reduce((o, t) => "group" in t ? p(p({}, o), qe(t.items)) : (o[t.value] = t, o), {});
}
var T = { dropdown: "m_88b62a41", search: "m_985517d8", options: "m_b2821a6e", option: "m_92253aa5", empty: "m_2530cd1d", header: "m_858f94bd", footer: "m_82b967cb", group: "m_254f3e4f", groupLabel: "m_2bb2e9e5", chevron: "m_2943220b", optionsDropdownOption: "m_390b5f4", optionsDropdownCheckIcon: "m_8ee53fc2" };
const ze = {
  error: null
}, Ke = ce((e, { size: o, color: t }) => ({
  chevron: {
    "--combobox-chevron-size": K(o, "combobox-chevron-size"),
    "--combobox-chevron-color": t ? ke(t, e) : void 0
  }
})), G = P((e, o) => {
  const t = N("ComboboxChevron", ze, e), C = t, { size: r, error: c, style: l, className: n, classNames: d, styles: s, unstyled: a, vars: u, mod: i } = C, m = w(C, ["size", "error", "style", "className", "classNames", "styles", "unstyled", "vars", "mod"]), f = ie({
    name: "ComboboxChevron",
    classes: T,
    props: t,
    style: l,
    className: n,
    classNames: d,
    styles: s,
    unstyled: a,
    vars: u,
    varsResolver: Ke,
    rootSelector: "chevron"
  });
  return /* @__PURE__ */ v(
    L,
    O(p(p({
      component: "svg"
    }, m), f("chevron")), {
      size: r,
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      mod: ["combobox-chevron", { error: c }, i],
      ref: o,
      children: /* @__PURE__ */ v(
        "path",
        {
          d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
});
G.classes = T;
G.displayName = "@mantine/core/ComboboxChevron";
const [Ve, E] = Re(
  "Combobox component was not found in tree"
), ue = De(
  (n, l) => {
    var d = n, { size: e, onMouseDown: o, onClick: t, onClear: r } = d, c = w(d, ["size", "onMouseDown", "onClick", "onClear"]);
    return /* @__PURE__ */ v(
      de.ClearButton,
      O(p({
        ref: l,
        tabIndex: -1,
        "aria-hidden": !0
      }, c), {
        onMouseDown: (s) => {
          s.preventDefault(), o == null || o(s);
        },
        onClick: (s) => {
          r(), t == null || t(s);
        }
      })
    );
  }
);
ue.displayName = "@mantine/core/ComboboxClearButton";
const Be = {}, j = P((e, o) => {
  const a = N(
    "ComboboxDropdown",
    Be,
    e
  ), { classNames: t, styles: r, className: c, style: l, hidden: n } = a, d = w(a, ["classNames", "styles", "className", "style", "hidden"]), s = E();
  return /* @__PURE__ */ v(
    z.Dropdown,
    p(O(p({}, d), {
      ref: o,
      role: "presentation",
      "data-hidden": n || void 0
    }), s.getStyles("dropdown", { className: c, style: l, classNames: t, styles: r }))
  );
});
j.classes = T;
j.displayName = "@mantine/core/ComboboxDropdown";
const Ge = {
  refProp: "ref"
}, pe = P((e, o) => {
  const { children: t, refProp: r } = N("ComboboxDropdownTarget", Ge, e);
  if (E(), !V(t))
    throw new Error(
      "Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  return /* @__PURE__ */ v(z.Target, { ref: o, refProp: r, children: t });
});
pe.displayName = "@mantine/core/ComboboxDropdownTarget";
const je = {}, M = P((e, o) => {
  const a = N(
    "ComboboxEmpty",
    je,
    e
  ), { classNames: t, className: r, style: c, styles: l, vars: n } = a, d = w(a, ["classNames", "className", "style", "styles", "vars"]), s = E();
  return /* @__PURE__ */ v(
    L,
    p(p({
      ref: o
    }, s.getStyles("empty", { className: r, classNames: t, styles: l, style: c })), d)
  );
});
M.classes = T;
M.displayName = "@mantine/core/ComboboxEmpty";
function U({
  onKeyDown: e,
  withKeyboardNavigation: o,
  withAriaAttributes: t,
  withExpandedAttribute: r,
  targetType: c,
  autoComplete: l
}) {
  const n = E(), [d, s] = $e(null), a = (i) => {
    if (e == null || e(i), !n.readOnly && o) {
      if (i.nativeEvent.isComposing)
        return;
      if (i.nativeEvent.code === "ArrowDown" && (i.preventDefault(), n.store.dropdownOpened ? s(n.store.selectNextOption()) : (n.store.openDropdown("keyboard"), s(n.store.selectActiveOption()), n.store.updateSelectedOptionIndex("selected", { scrollIntoView: !0 }))), i.nativeEvent.code === "ArrowUp" && (i.preventDefault(), n.store.dropdownOpened ? s(n.store.selectPreviousOption()) : (n.store.openDropdown("keyboard"), s(n.store.selectActiveOption()), n.store.updateSelectedOptionIndex("selected", { scrollIntoView: !0 }))), i.nativeEvent.code === "Enter" || i.nativeEvent.code === "NumpadEnter") {
        if (i.nativeEvent.keyCode === 229)
          return;
        const m = n.store.getSelectedOptionIndex();
        n.store.dropdownOpened && m !== -1 ? (i.preventDefault(), n.store.clickSelectedOption()) : c === "button" && (i.preventDefault(), n.store.openDropdown("keyboard"));
      }
      i.key === "Escape" && n.store.closeDropdown("keyboard"), i.nativeEvent.code === "Space" && c === "button" && (i.preventDefault(), n.store.toggleDropdown("keyboard"));
    }
  }, u = t ? {
    "aria-haspopup": "listbox",
    "aria-expanded": r && !!(n.store.listId && n.store.dropdownOpened) || void 0,
    "aria-controls": n.store.dropdownOpened ? n.store.listId : void 0,
    "aria-activedescendant": n.store.dropdownOpened && d || void 0,
    autoComplete: l,
    "data-expanded": n.store.dropdownOpened || void 0,
    "data-mantine-stop-propagation": n.store.dropdownOpened || void 0
  } : {};
  return O(p({}, u), {
    onKeyDown: a
  });
}
const Me = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: !0,
  withAriaAttributes: !0,
  withExpandedAttribute: !1,
  autoComplete: "off"
}, be = P((e, o) => {
  const m = N("ComboboxEventsTarget", Me, e), {
    children: t,
    refProp: r,
    withKeyboardNavigation: c,
    withAriaAttributes: l,
    withExpandedAttribute: n,
    targetType: d,
    autoComplete: s
  } = m, a = w(m, [
    "children",
    "refProp",
    "withKeyboardNavigation",
    "withAriaAttributes",
    "withExpandedAttribute",
    "targetType",
    "autoComplete"
  ]);
  if (!V(t))
    throw new Error(
      "Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const u = E(), i = U({
    targetType: d,
    withAriaAttributes: l,
    withKeyboardNavigation: c,
    withExpandedAttribute: n,
    onKeyDown: t.props.onKeyDown,
    autoComplete: s
  });
  return se(t, O(p(p({}, i), a), {
    [r]: B(o, u.store.targetRef, Le(t))
  }));
});
be.displayName = "@mantine/core/ComboboxEventsTarget";
const Ue = {}, Z = P((e, o) => {
  const a = N(
    "ComboboxFooter",
    Ue,
    e
  ), { classNames: t, className: r, style: c, styles: l, vars: n } = a, d = w(a, ["classNames", "className", "style", "styles", "vars"]), s = E();
  return /* @__PURE__ */ v(
    L,
    O(p(p({
      ref: o
    }, s.getStyles("footer", { className: r, classNames: t, style: c, styles: l })), d), {
      onMouseDown: (u) => {
        u.preventDefault();
      }
    })
  );
});
Z.classes = T;
Z.displayName = "@mantine/core/ComboboxFooter";
const Ze = {}, J = P((e, o) => {
  const i = N(
    "ComboboxGroup",
    Ze,
    e
  ), { classNames: t, className: r, style: c, styles: l, vars: n, children: d, label: s } = i, a = w(i, ["classNames", "className", "style", "styles", "vars", "children", "label"]), u = E();
  return /* @__PURE__ */ Te(
    L,
    O(p(p({
      ref: o
    }, u.getStyles("group", { className: r, classNames: t, style: c, styles: l })), a), {
      children: [
        s && /* @__PURE__ */ v("div", O(p({}, u.getStyles("groupLabel", { classNames: t, styles: l })), { children: s })),
        d
      ]
    })
  );
});
J.classes = T;
J.displayName = "@mantine/core/ComboboxGroup";
const Je = {}, Q = P((e, o) => {
  const a = N(
    "ComboboxHeader",
    Je,
    e
  ), { classNames: t, className: r, style: c, styles: l, vars: n } = a, d = w(a, ["classNames", "className", "style", "styles", "vars"]), s = E();
  return /* @__PURE__ */ v(
    L,
    O(p(p({
      ref: o
    }, s.getStyles("header", { className: r, classNames: t, style: c, styles: l })), d), {
      onMouseDown: (u) => {
        u.preventDefault();
      }
    })
  );
});
Q.classes = T;
Q.displayName = "@mantine/core/ComboboxHeader";
function me(r) {
  var c = r, {
    value: e,
    valuesDivider: o = ","
  } = c, t = w(c, [
    "value",
    "valuesDivider"
  ]);
  return /* @__PURE__ */ v(
    "input",
    p({
      type: "hidden",
      value: Array.isArray(e) ? e.join(o) : e || ""
    }, t)
  );
}
me.displayName = "@mantine/core/ComboboxHiddenInput";
const Qe = {}, W = P((e, o) => {
  const t = N("ComboboxOption", Qe, e), h = t, {
    classNames: r,
    className: c,
    style: l,
    styles: n,
    vars: d,
    onClick: s,
    id: a,
    active: u,
    onMouseDown: i,
    onMouseOver: m,
    disabled: f,
    selected: C,
    mod: $
  } = h, k = w(h, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "onClick",
    "id",
    "active",
    "onMouseDown",
    "onMouseOver",
    "disabled",
    "selected",
    "mod"
  ]), S = E(), F = _e(), _ = a || F;
  return /* @__PURE__ */ v(
    L,
    O(p(p({}, S.getStyles("option", { className: c, classNames: r, styles: n, style: l })), k), {
      ref: o,
      id: _,
      mod: [
        "combobox-option",
        { "combobox-active": u, "combobox-disabled": f, "combobox-selected": C },
        $
      ],
      role: "option",
      onClick: (D) => {
        var H;
        f ? D.preventDefault() : ((H = S.onOptionSubmit) == null || H.call(S, t.value, t), s == null || s(D));
      },
      onMouseDown: (D) => {
        D.preventDefault(), i == null || i(D);
      },
      onMouseOver: (D) => {
        S.resetSelectionOnOptionHover && S.store.resetSelectedOption(), m == null || m(D);
      }
    })
  );
});
W.classes = T;
W.displayName = "@mantine/core/ComboboxOption";
const We = {}, X = P((e, o) => {
  const f = N("ComboboxOptions", We, e), { classNames: r, className: c, style: l, styles: n, id: d, onMouseDown: s, labelledBy: a } = f, u = w(f, ["classNames", "className", "style", "styles", "id", "onMouseDown", "labelledBy"]), i = E(), m = Fe(d);
  return ae(() => {
    i.store.setListId(m);
  }, [m]), /* @__PURE__ */ v(
    L,
    O(p(p({
      ref: o
    }, i.getStyles("options", { className: c, style: l, classNames: r, styles: n })), u), {
      id: m,
      role: "listbox",
      "aria-labelledby": a,
      onMouseDown: (C) => {
        C.preventDefault(), s == null || s(C);
      }
    })
  );
});
X.classes = T;
X.displayName = "@mantine/core/ComboboxOptions";
const Xe = {
  withAriaAttributes: !0,
  withKeyboardNavigation: !0
}, Y = P((e, o) => {
  const $ = N("ComboboxSearch", Xe, e), {
    classNames: r,
    styles: c,
    unstyled: l,
    vars: n,
    withAriaAttributes: d,
    onKeyDown: s,
    withKeyboardNavigation: a,
    size: u
  } = $, i = w($, [
    "classNames",
    "styles",
    "unstyled",
    "vars",
    "withAriaAttributes",
    "onKeyDown",
    "withKeyboardNavigation",
    "size"
  ]), m = E(), f = m.getStyles("search"), C = U({
    targetType: "input",
    withAriaAttributes: d,
    withKeyboardNavigation: a,
    withExpandedAttribute: !1,
    onKeyDown: s,
    autoComplete: "off"
  });
  return /* @__PURE__ */ v(
    de,
    O(p(p({
      ref: B(o, m.store.searchRef),
      classNames: [{ input: f.className }, r],
      styles: [{ input: f.style }, c],
      size: u || m.size
    }, C), i), {
      __staticSelector: "Combobox"
    })
  );
});
Y.classes = T;
Y.displayName = "@mantine/core/ComboboxSearch";
const Ye = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: !0,
  withAriaAttributes: !0,
  withExpandedAttribute: !1,
  autoComplete: "off"
}, fe = P((e, o) => {
  const f = N("ComboboxTarget", Ye, e), {
    children: t,
    refProp: r,
    withKeyboardNavigation: c,
    withAriaAttributes: l,
    withExpandedAttribute: n,
    targetType: d,
    autoComplete: s
  } = f, a = w(f, [
    "children",
    "refProp",
    "withKeyboardNavigation",
    "withAriaAttributes",
    "withExpandedAttribute",
    "targetType",
    "autoComplete"
  ]);
  if (!V(t))
    throw new Error(
      "Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const u = E(), i = U({
    targetType: d,
    withAriaAttributes: l,
    withKeyboardNavigation: c,
    withExpandedAttribute: n,
    onKeyDown: t.props.onKeyDown,
    autoComplete: s
  }), m = se(t, p(p({}, i), a));
  return /* @__PURE__ */ v(z.Target, { ref: B(o, u.store.targetRef), children: m });
});
fe.displayName = "@mantine/core/ComboboxTarget";
function eo(e, o, t) {
  for (let r = e - 1; r >= 0; r -= 1)
    if (!o[r].hasAttribute("data-combobox-disabled"))
      return r;
  if (t) {
    for (let r = o.length - 1; r > -1; r -= 1)
      if (!o[r].hasAttribute("data-combobox-disabled"))
        return r;
  }
  return e;
}
function oo(e, o, t) {
  for (let r = e + 1; r < o.length; r += 1)
    if (!o[r].hasAttribute("data-combobox-disabled"))
      return r;
  if (t) {
    for (let r = 0; r < o.length; r += 1)
      if (!o[r].hasAttribute("data-combobox-disabled"))
        return r;
  }
  return e;
}
function to(e) {
  for (let o = 0; o < e.length; o += 1)
    if (!e[o].hasAttribute("data-combobox-disabled"))
      return o;
  return -1;
}
function ro({
  defaultOpened: e,
  opened: o,
  onOpenedChange: t,
  onDropdownClose: r,
  onDropdownOpen: c,
  loop: l = !0,
  scrollBehavior: n = "instant"
} = {}) {
  const [d, s] = He({
    value: o,
    defaultValue: e,
    finalValue: !1,
    onChange: t
  }), a = R(null), u = R(-1), i = R(null), m = R(null), f = R(-1), C = R(-1), $ = R(-1), k = y(
    (b = "unknown") => {
      d || (s(!0), c == null || c(b));
    },
    [s, c, d]
  ), S = y(
    (b = "unknown") => {
      d && (s(!1), r == null || r(b));
    },
    [s, r, d]
  ), F = y(
    (b = "unknown") => {
      d ? S(b) : k(b);
    },
    [S, k, d]
  ), _ = y(() => {
    const b = document.querySelector(`#${a.current} [data-combobox-selected]`);
    b == null || b.removeAttribute("data-combobox-selected"), b == null || b.removeAttribute("aria-selected");
  }, []), h = y(
    (b) => {
      const A = document.getElementById(a.current), g = A == null ? void 0 : A.querySelectorAll("[data-combobox-option]");
      if (!g)
        return null;
      const I = b >= g.length ? 0 : b < 0 ? g.length - 1 : b;
      return u.current = I, g != null && g[I] && !g[I].hasAttribute("data-combobox-disabled") ? (_(), g[I].setAttribute("data-combobox-selected", "true"), g[I].setAttribute("aria-selected", "true"), g[I].scrollIntoView({ block: "nearest", behavior: n }), g[I].id) : null;
    },
    [n, _]
  ), D = y(() => {
    const b = document.querySelector(
      `#${a.current} [data-combobox-active]`
    );
    if (b) {
      const A = document.querySelectorAll(
        `#${a.current} [data-combobox-option]`
      ), g = Array.from(A).findIndex((I) => I === b);
      return h(g);
    }
    return h(0);
  }, [h]), H = y(
    () => h(
      oo(
        u.current,
        document.querySelectorAll(`#${a.current} [data-combobox-option]`),
        l
      )
    ),
    [h, l]
  ), xe = y(
    () => h(
      eo(
        u.current,
        document.querySelectorAll(`#${a.current} [data-combobox-option]`),
        l
      )
    ),
    [h, l]
  ), he = y(
    () => h(
      to(
        document.querySelectorAll(`#${a.current} [data-combobox-option]`)
      )
    ),
    [h]
  ), ge = y(
    (b = "selected", A) => {
      $.current = window.setTimeout(() => {
        var ee;
        const g = document.querySelectorAll(
          `#${a.current} [data-combobox-option]`
        ), I = Array.from(g).findIndex(
          (Ae) => Ae.hasAttribute(`data-combobox-${b}`)
        );
        u.current = I, A != null && A.scrollIntoView && ((ee = g[I]) == null || ee.scrollIntoView({ block: "nearest", behavior: n }));
      }, 0);
    },
    []
  ), ye = y(() => {
    u.current = -1, _();
  }, [_]), ve = y(() => {
    const b = document.querySelectorAll(
      `#${a.current} [data-combobox-option]`
    ), A = b == null ? void 0 : b[u.current];
    A == null || A.click();
  }, []), we = y((b) => {
    a.current = b;
  }, []), Ce = y(() => {
    f.current = window.setTimeout(() => i.current.focus(), 0);
  }, []), Se = y(() => {
    C.current = window.setTimeout(() => m.current.focus(), 0);
  }, []), Oe = y(() => u.current, []);
  return ae(
    () => () => {
      window.clearTimeout(f.current), window.clearTimeout(C.current), window.clearTimeout($.current);
    },
    []
  ), {
    dropdownOpened: d,
    openDropdown: k,
    closeDropdown: S,
    toggleDropdown: F,
    selectedOptionIndex: u.current,
    getSelectedOptionIndex: Oe,
    selectOption: h,
    selectFirstOption: he,
    selectActiveOption: D,
    selectNextOption: H,
    selectPreviousOption: xe,
    resetSelectedOption: ye,
    updateSelectedOptionIndex: ge,
    listId: a.current,
    setListId: we,
    clickSelectedOption: ve,
    searchRef: i,
    focusSearchInput: Ce,
    targetRef: m,
    focusTarget: Se
  };
}
const no = {
  keepMounted: !0,
  withinPortal: !0,
  resetSelectionOnOptionHover: !1,
  width: "target",
  transitionProps: { transition: "fade", duration: 0 }
}, so = ce((e, { size: o, dropdownPadding: t }) => ({
  options: {
    "--combobox-option-fz": ne(o),
    "--combobox-option-padding": K(o, "combobox-option-padding")
  },
  dropdown: {
    "--combobox-padding": t === void 0 ? void 0 : Ee(t),
    "--combobox-option-fz": ne(o),
    "--combobox-option-padding": K(o, "combobox-option-padding")
  }
}));
function x(e) {
  const o = N("Combobox", no, e), h = o, {
    classNames: t,
    styles: r,
    unstyled: c,
    children: l,
    store: n,
    vars: d,
    onOptionSubmit: s,
    onClose: a,
    size: u,
    dropdownPadding: i,
    resetSelectionOnOptionHover: m,
    __staticSelector: f,
    readOnly: C
  } = h, $ = w(h, [
    "classNames",
    "styles",
    "unstyled",
    "children",
    "store",
    "vars",
    "onOptionSubmit",
    "onClose",
    "size",
    "dropdownPadding",
    "resetSelectionOnOptionHover",
    "__staticSelector",
    "readOnly"
  ]), k = ro(), S = n || k, F = ie({
    name: f || "Combobox",
    classes: T,
    props: o,
    classNames: t,
    styles: r,
    unstyled: c,
    vars: d,
    varsResolver: so
  }), _ = () => {
    a == null || a(), S.closeDropdown();
  };
  return /* @__PURE__ */ v(
    Ve,
    {
      value: {
        getStyles: F,
        store: S,
        onOptionSubmit: s,
        size: u,
        resetSelectionOnOptionHover: m,
        readOnly: C
      },
      children: /* @__PURE__ */ v(
        z,
        O(p({
          opened: S.dropdownOpened
        }, $), {
          onChange: (D) => !D && _(),
          withRoles: !1,
          unstyled: c,
          children: l
        })
      )
    }
  );
}
const ao = (e) => e;
x.extend = ao;
x.classes = T;
x.displayName = "@mantine/core/Combobox";
x.Target = fe;
x.Dropdown = j;
x.Options = X;
x.Option = W;
x.Search = Y;
x.Empty = M;
x.Chevron = G;
x.Footer = Z;
x.Header = Q;
x.EventsTarget = be;
x.DropdownTarget = pe;
x.Group = J;
x.ClearButton = ue;
x.HiddenInput = me;
export {
  x as C,
  qe as a,
  T as c,
  Oo as g,
  ro as u
};
